import { render, staticRenderFns } from "./BuildingProtocols.vue?vue&type=template&id=6e686d90&scoped=true"
import script from "./BuildingProtocols.vue?vue&type=script&lang=js"
export * from "./BuildingProtocols.vue?vue&type=script&lang=js"
import style0 from "./BuildingProtocols.vue?vue&type=style&index=0&id=6e686d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e686d90",
  null
  
)

export default component.exports